import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import LinkLocale from '../../../../modules/i18n/LinkLocale'
import {
  LOCALE_EN,
  LOCALE_JA,
  LOCALE_KO,
  LOCALE_VI,
  LOCALE_ZH_CHS,
  LOCALE_ZH_CHT,
} from '../../../../modules/i18n/config'
import client from '../../../../modules/sanityClient'
import { BLOG_DETAIL_BANNER_QUERY } from '../../../../sanity/groqQueries'
import { BLOG_DETAIL_BANNER_QUERYResult } from '../../../../sanity/types'

const getTypeForLanguage = (lang) => {
  if (lang === LOCALE_KO) return 'blogMainPost'
  if (lang === LOCALE_EN) return 'blogMainPostEn'
  if (lang === LOCALE_JA) return 'blogMainPostJa'
  if (lang === LOCALE_VI) return 'blogMainPostVi'
  if (lang === LOCALE_ZH_CHS) return 'blogMainPostZhs'
  if (lang === LOCALE_ZH_CHT) return 'blogMainPostZht'
  return 'blogMainPost'
}

const fetchBannerByLanguage = async (lang) => {
  const type = getTypeForLanguage(lang)

  const params = {
    type: type,
  }

  const data: BLOG_DETAIL_BANNER_QUERYResult = await client.fetch(BLOG_DETAIL_BANNER_QUERY, params)

  return data
}

const BlogDetailDesktopBannerSection = () => {
  const { query } = useRouter()
  const [banner, setBanner] = useState<any>({
    bannerTitle: '',
    bannerButtonTitle: '',
    bannerButtonLink: '',
  })
  const {
    data: bannerData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['banner'],
    queryFn: () => fetchBannerByLanguage(query.lang),
  })

  useEffect(() => {
    if (bannerData) {
      // 사용할 때 banner를 사용하세요
      setBanner(bannerData?.commonBanner)
    }
  }, [bannerData])

  if (isLoading) {
    // 로딩 상태 처리
    return <div className={style.bannerLayout}></div>
  }

  if (isError) {
    // 에러 처리
    return <div></div>
  }

  return (
    <div className={style.bannerLayout}>
      <div className={style.title} style={{ whiteSpace: 'pre-line' }}>
        {banner.bannerTitle}
      </div>
      <div className={style.button}>
        {banner.bannerButtonLink?.includes('https') ? (
          <a href={banner.bannerButtonLink} target={'_blank'} rel={'noreferrer'}>
            <DSButton size={BUTTON_SIZE.XL} type={BUTTON_TYPE.SOLID} onClick={() => console.log('')}>
              <DSButton.Label>{banner.bannerButtonTitle}</DSButton.Label>
            </DSButton>
          </a>
        ) : (
          <LinkLocale href={banner.bannerButtonLink}>
            <DSButton size={BUTTON_SIZE.XL} type={BUTTON_TYPE.SOLID} onClick={() => console.log('')}>
              <DSButton.Label className="whitespace-nowrap">{banner.bannerButtonTitle}</DSButton.Label>
            </DSButton>
          </LinkLocale>
        )}
      </div>
    </div>
  )
}

export default BlogDetailDesktopBannerSection

const style = {
  bannerLayout: `flex min-h-[272px] flex-col items-center justify-center bg-purple-50 py-[60px] text-center`,
  title: `Hero3-36Bd`,
  button: `mt-[40px] w-[292px]`,
}
